import React, {useEffect} from "react";
import { Column, Columns, Table } from "@allxsmith/bestax-bulma";
import { readableDate } from "../../utils";
import logo from "../Nav/img/Logo.jpg";

class PrintPickList extends React.Component {

  render() {

    const quote = this.props.data;
    const {vehicle} = quote;
    const parts = quote.estimated_work_items.reduce((allParts, workItem) => {
      const parts = workItem.parts.map((part) => {
        return {
          ...part,
          workDescription: workItem.description
        }
      });
      return [...allParts, ...parts];
    }, []);
    const totalPartRows = 15 - parts.length;
    let blankRows = [];
    for (let i = 0; i < totalPartRows; i++) {
      blankRows.push(
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
      );
    }
    return (
      <div className={"print-landscape"}>
        <Columns isMultiline>
          <h2 className="quote-card-print-title" data-testid={"title"}>
            {quote.vehicle.registration}{quote.vehicle.vin_number ? '/' + quote.vehicle.vin_number : ""}
          </h2>
        </Columns>

        <Columns isMultiline>
          <Column>
            <div>
              <Table isBordered>
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>Customer2</th>
                    <th>Quote ID</th>
                  </tr>
                </thead>
                <tr>
                  <td data-testid={"customer1"}>{quote.customer ? quote.customer.display_name : ""}</td>
                  <td data-testid={"customer2"}>{quote.customer2 ? quote.customer2.display_name : ""}</td>
                  <td data-testid={"quote-id"}>{quote.id}</td>
                </tr>
              </Table>
              <Table isBordered isFullwidth>
                <thead>
                <tr>
                  <td colSpan={2} className="cell-header"><b>MAKE / MODEL:</b></td>
                  <td colSpan={4} data-testid={"vehicle-make/model"}>{vehicle.make ? vehicle.make.name : ""} - {vehicle.model ? vehicle.model.name : ""}</td>
                </tr>
                <tr className="header-row">
                  <td>Part Description</td>
                  <td>Part Number</td>
                  <td>Supplier</td>
                  <td>Part Stock</td>
                  <td>Part Used</td>
                  <td>Part Needs Replacing</td>
                </tr>
                </thead>
                <tbody>
                {
                  parts.map(({workDescription, ...part}, index) => <tr key={`${index}`}>
                    <td data-testid={"part-picklist-name"+index}>{part.name ?? ''}</td>
                    <td data-testid={"part-number"+index}>{part.part_number ?? ''}</td>
                    <td data-testid={"part-supplier"+index}>{part.supplier?.display_name ?? ''}</td>
                  </tr>)
                }
                {
                            blankRows.map(row => row)
                }
                </tbody>
              </Table>
            </div>
          </Column>
        </Columns>
      </div>
    );
  }
}

export default PrintPickList;
